var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",staticClass:"noBorder",class:_vm.agentClass,staticStyle:{"height":"600px"},attrs:{"src":_vm.url,"frameborder":"0","scrolling":_vm.scrolling},on:{"load":_vm.loaded}})}
var staticRenderFns = []

export { render, staticRenderFns }